<template>
  <div class="collapse-form">
    <el-form :model="enInform" ref="enInform" :label-width="labelWidth" :validate-on-rule-change="validateOnRuleChange" :inline-message="inlineMessage">
      <el-collapse v-model="activeNames" style="margin:20px 0px;">
        <el-collapse-item
          v-for="(item, index) in formConfigList"
          :title="item.title"
          :name="item.name"
          :key="index"
          :class="item.class ? item.class : ''"
        >
          <template slot="title">
            <i
              :class="`header-icon el-icon-${item.icon}`"
              style="margin-right: 2px;"
            ></i>
            <p>
              {{ item.title
              }}<span
                :style="
                  `margin-left: 10px;color: ${item.tipColor ? item.tipColor : '#FF8D5A'}`
                "
                >{{ item.tip }}</span
              >
            </p>
            <el-tooltip aria-hidden popper-class="listPoperTip" effect="light" :placement="item.placement ? item.placement : 'bottom'">
              <div slot="content" class="content">
                <div class="text" v-for="(e,i) in item.tipsList" :key="i">
                  <slot :name="e.slotName" v-if="e.type === 'slot'" />
                  <div class="tit" v-else v-html="e.text"></div>
                </div>
              </div>
              <div>
                <div class="poperTipBtn" style="margin-left: 10px;" :key="index" v-if="item.tipsList && item.tipsList.length > 0"><i class="el-icon-info"></i>温馨提示</div>
              </div>
            </el-tooltip>
            <i
              class="el-collapse-item__icon el-collapse-item__arrow el-icon-d-arrow-left"
            ></i>
          </template>
          <el-row>
            <el-col :span="item.span ? item.span : span">
              <el-form-item
                ref="formItem"
                v-for="(item, index) in item.formConfigList"
                :class="item.class ? item.class : '' "
                :key="item.value"
                :label="item.label"
                :prop="item.value"
                :error="errRules ? errRules[item.value] : ''"
                :rules="item.rule ? item.rule : {}"
                style="text-align: left;"
                :style="item.style && item.width ? `width: ${item.width}` + item.style : item.width ? `width: ${item.width}` : item.style ? item.style : ''"
              >
                <!-- 提示 -->
                <span
                  slot="label"
                  style="display:inline-block;"
                  v-if="item.tipContent"
                >
                  <span>{{ item.label }}</span>
                  <el-tooltip
                    effect="dark"
                    :content="item.tipContent"
                    placement="bottom"
                  >
                    <i
                      :key="item.tipContent"
                      class="el-icon-wenhao"
                      style="color: #FF6262; font-size: 20px; vertical-align: middle; margin: 0 8px 2px 0; cursor: pointer;display: inline;"
                    />
                  </el-tooltip>
                </span>
                <!-- 悬浮提示 -->
                <el-tooltip v-if="item.tip" class="item" popper-class="formTips" effect="dark" :content="getClass(item.tip) !== 'Array' ? item.tip : ''" placement="top">
                  <div slot="content" class="content" v-if="getClass(item.tip) === 'Array'">
                    <div class="text" v-for="(e,i) in item.tip" :key="i">
                      <slot :name="e.slotName" v-if="e.type === 'slot'" />
                      <div class="tit" v-else v-html="e.text"></div>
                    </div>
                  </div>
                  <!-- solt -->
                  <template v-if="item.type === 'slot'">
                    <slot :name="item.slotName" />
                  </template>
                  <!-- 文字输入框 -->
                  <el-input
                    v-model="enInform[item.value]"
                    v-if="item.type === 'input'"
                    :disabled="item.disabled"
                    :clearable="item.clearable"
                    :maxlength="item.maxlength"
                    :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                  ></el-input>
                  <!-- 数字输入框 带点击 -->
                  <el-input-number
                    v-model.number="enInform[item.value]"
                    :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                    v-if="item.type === 'elNumber'"
                    controls-position="right"
                    :maxlength="item.maxlength ? item.maxlength : 99999"
                    :minlength="item.minlength ? item.minlength : 99999"
                    :clearable="item.clearable"
                    autocomplete
                    :disabled="item.disabled"
                  ></el-input-number>
                  <!-- 密码输入框 -->
                  <el-input
                    v-model="enInform[item.value]"
                    :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                    v-if="item.type === 'password'"
                    :clearable="item.clearable"
                    :disabled="item.disabled"
                    type="password"
                  ></el-input>
                  <!-- 数字输入框 -->
                  <el-input
                    v-model.number="enInform[item.value]"
                    :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                    v-if="item.type === 'number'"
                    :clearable="item.clearable"
                    :disabled="item.disabled"
                  ></el-input>
                  <!-- 文本域 -->
                  <el-input
                    type="textarea"
                    v-model="enInform[item.value]"
                    v-if="item.type === 'textarea'"
                    :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                    :clearable="item.clearable"
                    :disabled="item.disabled"
                    :autosize="{ minRows: item.minRows, maxRows: item.maxRows }"
                    :maxlength="item.maxlength ? item.maxlength : 99999"
                    :show-word-limit="item.showLimit ? true : false"
                  ></el-input>
                   <!-- 单选框 -->
                  <el-radio-group
                    v-model="enInform[item.value]"
                    :disabled="item.disabled"
                    v-if="item.type === 'radio'"
                    v-removeAriaHidden
                  >
                    <el-radio
                      v-for="(e, index) in item.option"
                      :key="index"
                      :label="e.value"
                      @change="fun_RadioChange($event, item.value, item.option)"
                      >{{ e.label }}</el-radio
                    >
                  </el-radio-group>
                  <!-- 复选选框 -->
                   <el-checkbox-group
                    v-model="enInform[item.value]"
                    :disabled="item.disabled"
                    v-if="item.type === 'checkbox'"
                    @change="fun_CheckboxChange($event, item.value)"
                  >
                    <el-checkbox
                      v-for="(item, index) in item.option"
                      :key="index"
                      :label="item.value"
                      >{{ item.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                   <!-- 下拉框 -->
                  <Co-select
                    :codeSting="enInform[item.value]"
                    :queryParams="item.queryParams ? item.queryParams : ''"
                    :clearable="item.clearable"
                    :disabled="item.disabled"
                    :filterable="item.filterable"
                    :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                    :optionData="item.optionData ? item.optionData : []"
                    v-if="item.type === 'select'"
                    @change="fun_SelectChange($event, item.value)"
                  />
                  <!-- 树形下拉框 -->
                  <Co-cascader
                    :codeSting="enInform[item.value]"
                    :sqlId="`${item.sqlId ? item.sqlId : ''}`"
                    :queryParams="item.queryParams"
                    :url="`${item.url ? item.url : ''}`"
                    :propsData="item.propsData"
                    :optionData="item.optionData ? item.optionData : []"
                    :clearable="item.clearable"
                    :disabled="item.disabled"
                    :showAllLevels="item.showAllLevels"
                    v-if="item.type === 'cascader'"
                    @change="fun_SelectChange($event, item.value)"
                  />
                   <!-- 日期选择框 -->
                  <el-date-picker
                    v-if="item.type === 'date' && !item.tip"
                    v-model="enInform[item.value]"
                    :type="item.dateType"
                    :picker-options="item.TimePickerOptions"
                    :clearable="item.clearable"
                    :disabled="item.disabled"
                    :editable="item.editable"
                    :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                    :value-format="`${item.valueFormat ? item.valueFormat : ''}`"
                    :format="`${item.format ? item.format : ''}`"
                    :popper-class="`${item.popperClass ? item.popperClass : ''}`"
                  />
                </el-tooltip>
                <!-- solt -->
                <template v-if="item.type === 'slot' && !item.tip">
                  <slot :name="item.slotName" />
                </template>
                <!-- 文字输入框 -->
                <el-input
                  v-model="enInform[item.value]"
                  v-if="item.type === 'input' && !item.tip"
                  :disabled="item.disabled"
                  :clearable="item.clearable"
                  :maxlength="item.maxlength"
                  :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                ></el-input>
                <span v-if="item.inputSpan" style="margin-left: 8px;">{{
                  item.inputSpan
                }}</span>
                <!-- 数字输入框 带点击 -->
                <el-input-number
                    v-model.number="enInform[item.value]"
                    :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                    v-if="item.type === 'elNumber' && !item.tip"
                    controls-position="right"
                    :maxlength="item.maxlength ? item.maxlength : 99999"
                    :minlength="item.minlength ? item.minlength : 99999"
                    :clearable="item.clearable"
                    autocomplete
                    :disabled="item.disabled"
                ></el-input-number>
                <!-- 密码输入框 -->
                <el-input
                  v-model="enInform[item.value]"
                  :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                  v-if="item.type === 'password' && !item.tip"
                  :clearable="item.clearable"
                  :disabled="item.disabled"
                  type="password"
                ></el-input>
                <!-- 数字输入框 -->
                <el-input
                  v-model.number="enInform[item.value]"
                  :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                  v-if="item.type === 'number' && !item.tip"
                  :clearable="item.clearable"
                  :disabled="item.disabled"
                ></el-input>
                <!-- 文本域 -->
                <el-input
                  type="textarea"
                  v-model="enInform[item.value]"
                  v-if="item.type === 'textarea' && !item.tip"
                  :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                  :clearable="item.clearable"
                  :disabled="item.disabled"
                  :maxlength="item.maxlength ? item.maxlength : 99999"
                  :show-word-limit="item.showLimit ? true : false"
                ></el-input>
                <!-- 单选框 -->
                <el-radio-group
                  v-model="enInform[item.value]"
                  :disabled="item.disabled"
                  v-if="item.type === 'radio' && !item.tip"
                  v-removeAriaHidden
                >
                  <el-radio
                    v-for="(e, index) in item.option"
                    :key="index"
                    :label="e.value"
                    @change="fun_RadioChange($event, item.value, item.option)"
                    >{{ e.label }}</el-radio
                  >
                </el-radio-group>
                <!-- 复选选框 -->
                <el-checkbox-group
                  v-model="enInform[item.value]"
                  :disabled="item.disabled"
                  v-if="item.type === 'checkbox' && !item.tip"
                  @change="fun_CheckboxChange($event, item.value)"
                >
                  <el-checkbox
                    v-for="(item, index) in item.option"
                    :key="index"
                    :label="item.value"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
                <!-- span -->
                <span style="color: red;" v-if="item.type === 'span'">{{
                  item.value
                }}</span>
                <!-- 下拉框 -->
                <Co-select
                  :codeSting="enInform[item.value]"
                  :queryParams="item.queryParams ? item.queryParams : ''"
                  :clearable="item.clearable"
                  :disabled="item.disabled"
                  :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                  :optionData="item.optionData ? item.optionData : []"
                  v-if="item.type === 'select' && !item.tip"
                  @change="fun_SelectChange($event, item.value)"
                />
                <!-- 树形下拉框 -->
                <Co-cascader
                  :codeSting="enInform[item.value]"
                  :sqlId="`${item.sqlId ? item.sqlId : ''}`"
                  :queryParams="item.queryParams"
                  :url="`${item.url ? item.url : ''}`"
                  :propsData="item.propsData"
                  :clearable="item.clearable"
                  :disabled="item.disabled"
                  :showAllLevels="item.showAllLevels"
                  :optionData="item.optionData ? item.optionData : []"
                  v-if="item.type === 'cascader' && !item.tip"
                  @change="fun_SelectChange($event, item.value)"
                />
                <!-- 日期选择框 -->
                <el-date-picker
                  v-if="item.type === 'date'"
                  v-model="enInform[item.value]"
                  :type="item.dateType"
                  :picker-options="item.TimePickerOptions"
                  :clearable="item.clearable"
                  :disabled="item.disabled"
                  :editable="item.editable"
                  :placeholder="`${item.placeholder ? item.placeholder : ''}`"
                  :value-format="`${item.valueFormat ? item.valueFormat : ''}`"
                  :format="`${item.format ? item.format : ''}`"
                  :popper-class="`${item.popperClass ? item.popperClass : ''}`"
                />
                <!-- 提示内容 -->
                <!-- <p v-if="item.tip" class="tip">
                  <span>{{ item.tip }}</span>
                </p> -->
              </el-form-item>
            </el-col>
            <div class="flieList" v-if="(flieList && flieList.length > 0) && index === 0">
              <div class="title">相关附件下载 <span><i class="el-icon-close" @click="fun_GetIsFlieList"></i></span></div>
              <div class="ul">
                <div class="li" v-for="(f,fIndex) in flieList" :key="fIndex">
                  <a :href="f.url">{{ f.name }}</a>
                </div>
              </div>
            </div>
          </el-row>
        </el-collapse-item>
        <!-- 按钮组 -->
        <div class="tjBtn" v-if="isBtn">
          <slot :name="btnSlotName"></slot>
          <el-button type="info" @click="fun_Back" v-if="workbenchMenu != '1'">返回</el-button>
        </div>
      </el-collapse>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: this.formConfigList.map(item => {
        return item.name;
      }), // 默认展开全部面板
      userFlag: null,
      // 用于判断是否为工作台公告流程
      workbenchMenu: sessionStorage.getItem("workbenchMenu"),
    };
  },
  created() {
    // 添加对 sessionStorage 的监听
    window.addEventListener("setItem", () => {
      // 当sessionStorage 中的lang值发生变化， 给组件中的值重新赋值
      this.userFlag = sessionStorage.getItem("userFlag") ? sessionStorage.getItem("userFlag") : null;
      // 获取是否为工作台公告流程状态
      this.workbenchMenu = sessionStorage.getItem("workbenchMenu") ? sessionStorage.getItem("workbenchMenu") : null;
    });
  },
   watch: {
    formConfigList() {
      this.activeNames = this.formConfigList.map(item => {
        return item.name;
      }) // 默认展开全部面板
    },
    workbenchMenu() {
      this.workbenchMenu = sessionStorage.getItem("workbenchMenu") ? sessionStorage.getItem("workbenchMenu") : null;
    }
  },
  props: {
    // 表单数据
    enInform: {
      type: Object
    },
    // 相关字段
    formConfigList: {
      type: Array
    },
    // 自定义验证规则
    errRules: {
      type: Object
    },
    // label宽度
    labelWidth: {
      type: String,
      default: "120px"
    },
    // 右下角button插槽
    btnSlotName: {
      type: String,
      default: null
    },
    // 是否显示底部按钮
    isBtn: {
      type: Boolean,
      default: true
    },
    // el-col span
    span: {
      type: Number,
      default: 20
    },
    // 相关附件
    flieList:{
      type: Array,
      default: () => {
        return [];
      }
    },
    // 是否在 rules 属性改变后立即触发一次验证
    validateOnRuleChange:{
      type: Boolean,
      default: true
    },
    // 是否以行内形式展示校验信息
    inlineMessage:{
      type: Boolean,
      default: false
    },
  },
  methods: {
    // 判断是类型
    getClass(o){
      return Object.prototype.toString.call(o).slice(8, -1);
    },
    // 返回按钮
    fun_Back(e) {
      this.$emit("fun_Back", e);
    },
    // 下拉框change事件
    fun_SelectChange($event, value, code, arr) {
      this.$emit("fun_GetSelectVal", $event.code, value, $event.options);
    },
    // 复选框change时间
    fun_CheckboxChange($event, value) {
      this.$emit("fun_GetCheckboxVal", $event, value);
    },
    // 单选框change时间
    fun_RadioChange(value, field, option) {
      this.$emit("fun_GetRadioVal", value, field, option);
    },
    // 关闭附件列表
    fun_GetIsFlieList(){
      // 清空
      this.flieList = [];
    },
  }
};
</script>
<style lang="scss" scoped>
.collapse-form {
  padding: 0 20px;
  box-sizing: border-box;
  /deep/.el-form {
    .el-collapse {
      border: 0;
      .el-collapse-item {
        .el-collapse-item__header {
          background: #ffffff;
          border-bottom: 1px solid #e9e9e9;
          p {
            font-weight: bold;
            color: rgba(0, 0, 0, 0.85);
            font-size: 16px;
            @media (min-width: 2160px) {
              font-size: 18px;
            }
            span {
              font-weight: 400;
            }
          }
          .el-collapse-item__arrow {
            display: none;
          }
          .el-collapse-item__icon {
            display: block;
            transform: rotate(-270deg);
          }
        }
        .is-active {
          .el-collapse-item__icon {
            display: block;
            transform: rotate(-90deg);
          }
        }
        .el-collapse-item__wrap {
          border: 0;
          .el-collapse-item__content {
            padding-bottom: 0px;
            .el-row{
              .flieList{
                position: fixed;
                right: 45px;
                border: 1px solid #E9E9E9;
                background: #FFFFFF;
                z-index: 999;
                .title{
                  font-weight: bold;
                  font-size: 16px;
                  color: #333333;
                  padding: 15px;
                  border-bottom: 1px solid #E9E9E9;
                  display: flex;
                  justify-content: space-between;
                  @media (min-width: 2160px) {
                    font-size: 18px;
                  }
                }
                .ul{
                  padding: 20px 15px;
                  .li{
                    margin-bottom: 15px;
                    &:last-child{
                      margin: 0;
                    }
                    a{
                      color: #333333;
                    }
                  }
                }
              }
              .el-col {
                .el-form-item {
                  width: 50%;
                  display: inline-block;
                  .el-form-item__content {
                    >div,>p,.btn{
                      display: flex;
                      align-items: center;
                      .el-button{
                        margin-left: 10px;
                        span{
                          display: inline-flex;
                          align-items: center;
                          img{
                            margin-right: 5px;
                          }
                        }
                      }
                    }
                    .tips{
                      align-items: flex-start;
                    }
                    .el-input, .el-select, .el-date-editor, .el-textarea, .el-input-number, .el-cascader{
                      width: 100% !important;
                      .el-textarea__inner{
                        width: 100% !important;
                      }
                    }
                    .tip {
                      display: inline-block;
                      margin-left: 10px;
                      font-size: 16px;
                      span {
                        color: #FF8D5A;
                        font-size: 16px;
                      }
                      @media (min-width: 2160px) {
                        font-size: 18px;
                        span{
                          font-size: 18px;
                        }
                      }
                    }
                    .layout-list{
                      .el-pagination{
                        .el-select {
                          width: 100px !important;
                          .el-input__inner{
                            height: auto;
                            line-height: unset !important;
                          }
                        }
                        .el-input{
                          width: auto !important;
                          .el-input__inner{
                            line-height: unset !important;
                          }
                        }
                      }
                    }
                  }
                }
                .formList{
                  width: 100% !important;
                  >.el-form-item__content {
                    margin-left: 0 !important;
                    .layout-list{
                      padding: 0;
                      margin: 0;
                    }
                  }
                }
                .formTextarea{
                  width: 100%;
                  .el-form-item__content {
                    .el-textarea{
                      width: 100%;
                      .el-textarea__inner{
                        width: 100%;
                      }
                    }
                  }
                }
                .noMargin{
                  .el-form-item__content {
                    margin-left: 0 !important;
                  }
                }
                .labelColor{
                  .el-form-item__label{
                    color: #FF6262;
                  }
                }
              }
            }
          }
        }
      }
      .collapseList{
          .el-collapse-item__wrap{
            .el-collapse-item__content{
              .el-row{
                .el-col{
                  width: 100%;
                }
              }
            }
          }
        }
    }
  }
  /deep/.el-form.staffElForm{
    .el-collapse {
      border: 0;
      .el-collapse-item {
        .el-collapse-item__wrap {
          .el-collapse-item__content {
            .el-row{
              .el-col {
                .el-form-item {
                  .el-form-item__label{
                    font-size: 14px;
                    line-height: 32px !important;
                    height: 32px;
                    span,p,div{
                      font-size: 14px;
                    }
                    @media (min-width: 2160px) {
                      font-size: 16px;
                      span,p,div{
                        font-size: 16px;
                      }
                    }
                  }
                  .el-form-item__content {
                    >div{
                      display: flex;
                    }
                    .el-input, .el-select, .el-date-editor, .el-textarea, .el-input-number, .el-cascader{
                      width: 100% !important;
                      .el-textarea__inner{
                        width: 100% !important;
                      }
                    }
                    .el-input__inner{
                      font-size: 14px;
                      line-height: 32px !important;
                      height: 32px;
                      @media (min-width: 2160px) {
                        font-size: 16px;
                      }
                    }
                    .tip {
                      font-size: 14px;
                      @media (min-width: 2160px) {
                        font-size: 16px;
                      }
                      span {
                        color: #FF8D5A;
                      }
                    }
                  }
                  // 错误提示样式
                  .el-form-item__error{
                    font-size: 14px !important;
                    @media (min-width: 2160px) {
                      font-size: 16px !important;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
